import { VueRegistration } from '@abaco/web-common/src/app';
const CONTEXT = "STANDARD_PORTAL";

const globals: VueRegistration = {

    "BuyerContractList": () => import("./components/tiles/contract/list.vue"),
    "BuyerContractDashboardList": () => import("./components/tiles/contract/dashboardList.vue"),
    "BuyerContractAdd": () => import("./components/tiles/contract/new.vue"),
    "BuyerContractDetail": () => import("./components/tiles/contract/detail/index.vue"),
    "BuyerContractThresholds": () => import("./components/tiles/subscription-management/index.vue"),
    "PaypalButton": () => import("./components/payment/PaypalButton.vue"),
    "PaymentIndex": () => import("./components/payment/index.vue")

};

export default globals;
